function cov_d5j499cvr() {
  var path = "/app/src/utils/is-valid-date.ts";
  var hash = "2f742d1b0e1f505dd8f636528c2a8a7e4ee7be0e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/is-valid-date.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 27
        },
        end: {
          line: 3,
          column: 1
        }
      },
      "1": {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 2,
          column: 57
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 1,
            column: 27
          },
          end: {
            line: 1,
            column: 28
          }
        },
        loc: {
          start: {
            line: 1,
            column: 39
          },
          end: {
            line: 3,
            column: 1
          }
        },
        line: 1
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 9
          },
          end: {
            line: 2,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 2,
            column: 9
          },
          end: {
            line: 2,
            column: 26
          }
        }, {
          start: {
            line: 2,
            column: 30
          },
          end: {
            line: 2,
            column: 56
          }
        }],
        line: 2
      }
    },
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2f742d1b0e1f505dd8f636528c2a8a7e4ee7be0e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_d5j499cvr = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_d5j499cvr();
cov_d5j499cvr().s[0]++;
export var isValidDate = function isValidDate(d) {
  cov_d5j499cvr().f[0]++;
  cov_d5j499cvr().s[1]++;
  return (cov_d5j499cvr().b[0][0]++, d instanceof Date) && (cov_d5j499cvr().b[0][1]++, !Number.isNaN(d.getTime()));
};